import "./DeltaFaucetSinkRepair.module.css";
import Header from "@/reusable_sections/Header";
import DeltaRepair from "./sections/DeltaRepair";
import DeltaFixtures from "./sections/DeltaFixtures";
import DeltaFaq from "./sections/DeltaFaq";
import Footer from "@/reusable_sections/Footer";
export default function DeltaFaucetSinkRepairPage() {
  return <div>
      <Header />
      <DeltaRepair />
      <DeltaFixtures />
      <DeltaFaq />
      <Footer />
    </div>;
}